import { ReactComponent as BinsProviderIcon } from './slot-bbin.svg';

export default { BinsProviderIcon };
